import { ApiKey, ApiKeyId, BriefStatusSchema, CreditAmount, OrganizationUid, SpendingLimit, UserHandle, UserUid, } from "@buildwithflux/models";
import { z } from "zod";
export const GetCreditReportRequestData = z.object({
    accountUid: z
        .string()
        .min(1)
        .refine((str) => true),
});
export const GiveConsentForPaidCreditsData = z.object({
    accountUid: z
        .string()
        .min(1)
        .refine((str) => true),
});
export const SnoozePaidCreditConsentData = z.object({
    accountUid: z
        .string()
        .min(1)
        .refine((str) => true),
});
export const SetCreditSpendingLimitRequestData = z.object({
    accountUid: z
        .string()
        .min(1)
        .refine((str) => true),
    spendingLimit: SpendingLimit,
});
export const SetAdminFreeCreditsRequestData = z.object({
    accountUid: z
        .string()
        .min(1)
        .refine((str) => true),
    freeCredits: CreditAmount,
});
export const UpdateThreadBriefStateRequestData = z.object({
    documentUid: z
        .string()
        .min(1)
        .refine((str) => true),
    threadUid: z.string().min(1),
    planFlags: z
        .object({
        isDisabled: z.boolean().optional(),
        stopRequested: z.boolean().optional(),
    })
        .optional(),
    briefStatus: BriefStatusSchema.optional(),
});
export const ClearBriefPlanRequestData = z.object({
    documentUid: z
        .string()
        .min(1)
        .refine((str) => true),
    threadUid: z.string().min(1),
});
export const ShadowbanPartsRequestData = z.object({
    // TODO: refine
    objectType: z.string(),
    uid: z.string(),
    reason: z.string(),
});
export const UploadFileForCommentRequestData = z.object({
    content: z.string().describe("base64 encoded file content"),
    mimeType: z.string(),
});
export const earliestPossibleProjectRestorePointTimestamp = Date.now() - 7 * 24 * 60 * 60 * 1000;
export const ProjectRestorePointTimestamp = z
    .number()
    .positive()
    .gte(earliestPossibleProjectRestorePointTimestamp, "Firestore restore point is too far in the past - must be within 7 days");
export const RestoreProjectRequestData = z.object({
    documentUid: z
        .string()
        .min(1)
        .refine((str) => true),
    fromTimestamp: ProjectRestorePointTimestamp,
    newOwnerHandle: UserHandle.nullish(),
    newOwnerOrganizationUid: OrganizationUid.nullish(),
});
export const ReconstructProjectRequestData = z.object({
    documentUid: z
        .string()
        .min(1)
        .refine((str) => true),
    actionRecordUid: z.string().min(1),
});
/**
 * Request data for restoring a project to a new project from a specific version (action record).
 * This creates a new project containing the document state at the specified action record.
 */
export const RestoreProjectToNewFromVersionRequestData = z.object({
    documentUid: z
        .string()
        .min(1)
        .refine((str) => true),
    actionRecordUid: z.string().min(1),
    newOwnerHandle: UserHandle.nullish(),
});
export const AcceptInviteFunctionData = z.object({
    documentUid: z
        .string()
        .min(1)
        .refine((str) => true),
    inviteUid: z.string().min(1),
    inviteHash: z.string().min(1),
});
export const SendAddUserRoleEmailFunctionData = z.object({
    inviterName: z.string().optional(),
    inviterHandle: UserHandle,
    inviteeUid: UserUid,
    inviteeEmail: z.string().email(),
    permissionTypeStr: z.string(),
    documentName: z.string().optional(),
    documentUid: z
        .string()
        .min(1)
        .refine((str) => true),
});
export const SendVerificationEmailFunctionData = z.object({
    emailAddress: z.string().email(),
});
export const VerifyEmailAddressFunctionData = z.object({
    emailAddress: z.string().email(),
});
export const CreateApiKeyResult = z.object({
    id: ApiKeyId,
    apiKey: ApiKey,
});
export const GetAdminStripeCustomerIdRequestData = z.object({
    accountUid: z
        .string()
        .min(1)
        .refine((str) => true),
});
export const GetAdminStripeCustomerIdResponseData = z.object({
    customerUid: z.string().nullable(),
    subscriptionData: z
        .object({
        payment: z
            .object({
            subscriptions: z.record(z.any()).optional(),
            copilotCreditSubscriptions: z.record(z.any()).optional(),
            generatedTrialSubscriptions: z.record(z.any()).optional(),
            addonSubscriptions: z.record(z.any()).optional(),
            subscriptionsMetadata: z.record(z.any()).optional(),
            customerUid: z.string(),
        })
            .optional(),
        plans: z
            .object({
            isEducational: z.boolean().optional(),
        })
            .nullable()
            .optional(),
        creationFlags: z
            .object({
            planEpoch: z.string(),
            planVariant: z.string().nullable().optional(),
            trialType: z.string().optional(),
            migratedFromPlanEpoch: z.string().optional(),
            paidCreditConsentRequired: z.string().optional(),
        })
            .optional(),
    })
        .nullable(),
});
/**
 * Request data for the userSoftDeleteAdmin function
 */
export const UserSoftDeleteAdminRequestData = z.object({
    userUid: UserUid,
    action: z.enum(["request-deletion", "undelete"]),
});
//# sourceMappingURL=shared.js.map